import React, { useState } from "react";
import "./wallet.css";
import { cancelAuction, giftNFT, listNFT, startAuction, unlistNFT } from "../../utilis/web3";

function Wallet(props) {
  const [price, setPrice] = useState(0.01);
  const [auctionPrice, setAuctionPrice] = useState(0.01);
  const [auctionDuration, setAuctionDuration] = useState(1);
  const [listed, setlisted] = useState(props.listed);
  const [auctioned, setAuctioned] = useState(props.auctioned);
  const [bid, setBid] = useState(props.bid);
  const [giftAddress, setGiftAddress] = useState("");

  const handlePriceChange = (event) => {
    setPrice(event.target.value);
  };

  const handleAuctionPriceChange = (event) => {
    setAuctionPrice(event.target.value);
  };

  const handleAuctionDurationChange = (event) => {
    setAuctionDuration(event.target.value);
  };

  const handleGiftAddressChange = (event) => {
    setGiftAddress(event.target.value);
  };

  function capitalizeWords(str) {
    return str
      .split("_") // Split the string at underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(" "); // Join the words back together with a space
  }

  const handleGiftNFT = async () => {
    const gifted = await giftNFT(props.address, giftAddress, props.tokenId);
    console.log("Gifted", gifted);
    if (gifted) {
      props.changeNFTs(props.tokenId);
    }
  };

  const handleStartAuction = async () => {
    const auctionStarted = await startAuction(props.address, props.tokenId, auctionPrice, auctionDuration)
    setAuctioned(auctionStarted)
  };

  const handleCancelAuction = async () => {
    const auctionCancelled = await cancelAuction(props.address, props.tokenId)
    setAuctioned(auctionCancelled)
  };

  const handleListNFT = async () => {
    const listed = await listNFT(props.address, props.tokenId, price);
    setlisted(listed);
  };

  const handleUnlistNFT = async () => {
    const unlisted = await unlistNFT(props.address, props.tokenId);
    setlisted(unlisted);
  };

  return (
    <>
      <div className={props.classList}>
        {props.logoClass !== undefined ? (
          <>
            <div className="logo" style={{ minHeight: "250px" }}>
              <img src={props.imgSrc} alt={props.name} />
            </div>
          </>
        ) : (
          <>
            <img src={props.imgSrc} alt={props.name} style={{ minHeight: "250px" }} />
          </>
        )}

        <p className="w-100 d-flex justify-content-between">
          <span>Supply: {props.supply}</span>
        </p>
        <p className="me-auto">
          {" "}
          <span className="">Chain: {props.blockchain}</span>
        </p>
        <p className="me-auto">Title: {props.name}</p>
        <p className="me-auto">
          Collection: {capitalizeWords(props.collection)}
        </p>
        <p className="me-auto">Description: {props.description}</p>
        {auctioned || bid ?
          <>
            <p className="me-auto">Starting Price: {props.startingAuctionPrice}</p>
            <p className="me-auto">Current Bid: {props.currentAuctionBid}</p>
            <p className="me-auto">Seller: {props.seller?.slice(0, 5)}...{props.seller?.slice(-4)}</p>
            <p className="me-auto">Current Bidder: {props.highestAuctionBidder?.slice(0, 5)}...{props.highestAuctionBidder?.slice(-4)}</p>
            <p className="me-auto">Duration: {props.duration}</p>
            <p className="me-auto">End Time: {props.endTime?.split(",")[0]}</p>
          </>
          : ""}
        {listed || auctioned || bid ? (
          <button className="btn" disabled={bid} onClick={listed ? handleUnlistNFT : auctioned ? handleCancelAuction : ""}>
            <img src="/img/icons/discover.svg" alt="" className="svg" />
            {listed ?
              "Unlist NFT" : auctioned ? "Cancel Auction" : "Bid Placed"
            }
          </button>
        ) : (
          <>
            <div className="form-group">
              <p className="me-auto">Price: In ETH</p>
              <input
                type="number"
                className="form-control"
                id="price"
                placeholder="0"
                onChange={handlePriceChange}
                value={price}
                min="0" // Minimum value is 0
                step="0.01" // Step value is 0.01
                required
              />
            </div>
            <button className="btn" onClick={handleListNFT}>
              <img src="/img/icons/discover.svg" alt="" className="svg" />
              List NFT
            </button>
            <div className="form-group mt-2">
              <p className="me-auto">Receiver's Address:</p>
              <input
                type="text"
                className="form-control"
                id="giftAddress"
                onChange={handleGiftAddressChange}
                placeholder="0xCB08BF3C93b348F9d6361DbB9b9E4019aaAAD834"
                required
              />
            </div>
            <button className="btn mt-2" onClick={handleGiftNFT}>
              <img src="/img/icons/discover.svg" alt="" className="svg" />
              Gift NFT
            </button>
            <div className="form-group mt-2">
              <p className="me-auto">Starting Price: In ETH:</p>
              <input
                type="text"
                className="form-control"
                id="auctionPrice"
                onChange={handleAuctionPriceChange}
                value={auctionPrice}
                min="0.01" // Minimum value is 0.01
                step="0.01" // Step value is 0.01
                required
              />
              <p className="me-auto">Duration: In Days:</p>
              <input
                type="text"
                className="form-control"
                id="auctionDays"
                onChange={handleAuctionDurationChange}
                value={auctionDuration}
                min="1" // Minimum value is 1
                min="7" // Maximum value is 7
                step="1" // Step value is 1
                required
              />
            </div>
            <button className="btn mt-2" onClick={handleStartAuction}>
              <img src="/img/icons/discover.svg" alt="" className="svg" />
              Put on Auction
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default Wallet;
